export const useIsConditionalContent = () => {
  // TODO: replace this hook with logic when other dynamic content types are introduced
  return true;
};
